import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import OperationCard from '../OperationCard';

const LinkOperationCard = ({ id, data }) => {
  const link = Number.isNaN(Number(id)) ? `/operacao/novasoperacoes/${id}` : `/operacao/${id}`;

  return (
    <Link to={link} style={{ textDecoration: 'none' }}>
      <OperationCard
        isHighlight={data.isHighlight}
        tagList={data.tagList}
        logoSRC={data.logoSRC}
        title={data.title}
        isNewOperations={Number.isNaN(Number(id))}
        codigoCamaraCompensasao={data.codigoCamaraCompensasao}
        subtitle={data.subtitle}
        maxProfit={data.maxProfit}
        maxLoss={data.maxLoss}
        commission={data.commission}
        price={data.price}
        closingDate={data.closingDate}
        objective={data.objective}
      />
    </Link>
  );
};

LinkOperationCard.propTypes = {
  id: PropTypes.string.isRequired,
  data: PropTypes.objectOf({
    isHighlight: PropTypes.bool.isRequired,
    tagList: PropTypes.arrayOf(PropTypes.string).isRequired,
    logoSRC: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    maxProfit: PropTypes.string.isRequired,
    maxLoss: PropTypes.string.isRequired,
    commission: PropTypes.string.isRequired,
    price: PropTypes.string.isRequired,
    closingDate: PropTypes.string.isRequired,
    objective: PropTypes.string.isRequired,
  }).isRequired,
};

export default LinkOperationCard;
